import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { control, Collection, olx } from 'openlayers';
import { MapComponent } from '../map.component';

@Component({
  selector: 'aol-control-defaults',
  template: ''
})
export class DefaultControlComponent implements OnInit, OnDestroy {
  instance: Collection<control.Control>;
  @Input() attribution: boolean;
  @Input() attributionOptions: olx.control.AttributionOptions;
  @Input() rotate: boolean;
  @Input() rotateOptions: olx.control.RotateOptions;
  @Input() zoom: boolean;
  @Input() zoomOptions: olx.control.ZoomOptions;

  constructor(private map: MapComponent) {}

  ngOnInit() {
    this.instance = control.defaults(this);
    this.instance.forEach((control) => this.map.instance.addControl(control));
  }

  ngOnDestroy() {
    this.instance.forEach((control) => this.map.instance.removeControl(control));
  }
}
